import ConfigurationItemRow from "features/configuration/GeneralConfiguration/ConfigurationItem/ConfigurationItemRow";
import usePriceRangeItem from "features/configuration/GeneralConfiguration/ConfigurationItem/usePriceRangeItem";
import { ConfigurationItem } from "types";
import PriceRangeInput from "common/Inputs/PriceRangeInput";

interface PriceRangeItemProps {
  item: ConfigurationItem;
}

const PriceRangeItem = ({ item }: PriceRangeItemProps) => {
  const {
    itemName,
    itemValue,
    itemValueModified,
    handleItemChange,
    validationMessage,
    error,
    precisionConfig,
  } = usePriceRangeItem(item);

  return (
    <ConfigurationItemRow
      nameComponent={itemName}
      extraInfoComponent={
        <PriceRangeInput
          minMax={itemValue}
          precisionConfig={precisionConfig}
          onValueChange={handleItemChange}
        />
      }
      itemValueModified={itemValueModified}
      validationMessage={validationMessage}
      isError={error}
    />
  );
};

export default PriceRangeItem;
